<template>  
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>    
    <Migalha label="Guias e Orientações"></Migalha>
    <v-layout row wrap v-show="showBox">
     <!-- <v-flex v-if="!flExibirFormAddDocumento && $verificaPerfilHabilitador()"  xs12 sm12 md12 class="text-xs-right p-l-10">
         <v-btn fab small color="primary" @click="flExibirFormAddDocumento = true;">
           <v-icon>add</v-icon>
        </v-btn> 
      </v-flex>-->

      <template v-if="$verificaPerfilHabilitadorMaster() && !flExibirFormEditDocumento">        
        <v-flex xs12 sm12 md12 infoDados>
          <v-card>
            <div>
              <div class="p-t-none">
                <div class="tituloBox">
                  <div class="bg-red barraTitulo"></div>
                  <h1 class="text-default font-size-14">
                    <strong>Adicionar Documento</strong>
                  </h1>
                </div>
              </div>
              <div class="clear"></div>
              <v-form ref="form">
                <v-layout row wrap>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      v-model="arquivo.nomDocumento"
                      maxlength="200"
                      label="Nome do documento *"                      
                      required
                      validate-on-blur
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-combobox
                      clearable
                      v-model="perfilDocumentoCAF"
                      :return-object="true"
                      :items="perfisDocumentos"
                      label="Selecione o Perfil *"                      
                      required
                      multiple
                      item-text="descricao"
                      item-value="tipo"
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <uploadFile
                      tamanhoMaximo="20MB"
                      label="Anexar Documento *"                       
                      v-model="arquivo.file"
                      accept=".pdf, .PDF"
                      ref="fileLimp"
                    />
                  </v-flex>

                  <v-layout row d-inline class="p-t-10">
                  <v-flex right>
                    <v-btn color="info" @click="salvarDocumento(false);">Salvar</v-btn>
                  </v-flex>
                </v-layout>  
                </v-layout>
                      
              </v-form>
            </div>            
          </v-card>
        </v-flex>
          
       
      </template>
      <template v-if="flExibirFormEditDocumento">
        <v-flex xs12 sm12 md12 infoDados>
          <v-card>
            <div>
              <div class="p-t-none">
                <div class="tituloBox">
                  <div class="bg-red barraTitulo"></div>
                  <h1 class="text-default font-size-14">
                    <strong>Adicionar Documento</strong>
                  </h1>
                </div>
              </div>
              <div class="clear"></div>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs4 sm4 md4>
                    <v-text-field
                      v-model="arquivo.nomDocumento"
                      maxlength="200"
                      label="Nome do documento *"                      
                      required
                      validate-on-blur
                    ></v-text-field>
                  </v-flex>   
                  <v-flex xs4 sm4 md4>
                    <v-combobox
                      clearable
                      v-model="perfilDocumentoCAF"
                      :return-object="true"
                      :items="perfisDocumentos"
                      label="Selecione o Perfil *"                      
                      required
                      multiple
                      item-text="descricao"
                      item-value="tipo"
                    ></v-combobox>
                  </v-flex>               
                  <v-flex xs4 sm4 md4 v-show="!arquivo.novoFile">
                      <v-text-field
                          :value="subStrUpload(arquivo.file)"
                          label="Anexar Documento *"
                          clearable
                          readonly
                          @click:clear="arquivo.file = null;arquivo.novoFile =true"
                          persistent-hint
                          v-model="arquivo.file"
                      ></v-text-field> 
                  </v-flex>
                
                  <v-flex xs4 sm4 md4 v-if="arquivo.novoFile">
                    <uploadFile
                      tamanhoMaximo="20MB"
                      label="Anexar Documento *"                     
                      required
                      v-model="arquivo.novoFile"
                      accept=".pdf, .PDF"
                    />
                  </v-flex>

                </v-layout>
              </v-form>
            </div>
          </v-card>

          <v-layout row d-inline class="p-t-10">
            <v-flex right>
              <v-btn color="info" @click="editarDocumento(arquivo.idArquivo);">Salvar</v-btn>
            </v-flex>
            <v-flex right>
              <v-btn @click="flExibirFormEditDocumento = false; limparCampos()">Cancelar</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </template>

      <v-flex v-if="!flExibirFormAddDocumento" infoDados>
        <v-card>
          <div v-if="documentos">
            <div class="p-t-none">
              <div class="tituloBox">
                <div class="bg-red barraTitulo"></div>
                <h1 class="text-default font-size-14">
                  <strong>Documentos</strong>
                </h1>
              </div>
            </div>
            <div class="clear"></div>
            <v-data-table
              :headers="headers"
              :items="documentos"
              :loading="loading"
              :hide-actions="true"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.nome }}</td>
                <td class="text-xs-center">{{ props.item.dataCriacao | dataFormatada }}</td>
                <td class="text-xs-center naoImprimir">
                   <a v-if="props.item.caminho" v-bind:href="Vue.prototype.$baseURL + '/arquivo/baixarArquivo/' + props.item.id" target="_blank">
                      <v-icon color="green">get_app</v-icon>
                  </a>
                   <a v-if="!flExibirFormAddDocumento && $verificaPerfilHabilitadorMaster()" @click="flExibirFormEditDocumento = true;editarArquivoMulti(props.item)">
                    <v-icon color="primary">edit</v-icon>                    
                  </a>                  
                  <a v-if="$verificaPerfilHabilitadorMaster()" @click="dialogDelete = true; idExclusao = props.item.idArquivo">
                    <v-icon color="red">delete</v-icon>
                  </a>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialogDelete" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirmar Exclusão</v-card-title>

        <v-card-text>
          <p>Tem certeza que deseja deletar este documento?</p>
        </v-card-text>

        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn color="default" @click="dialogDelete = false">Cancelar</v-btn>
          </v-flex>

          <v-flex sm6>
            <v-btn color="info" @click="excluirDocumento()">Confirmar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Topo from "../../../components/Topo";
import Migalha from "../../../components/migalha";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import arquivoService from "../../../services/arquivoService";
import Vue from 'vue';

export default {
  name: "guias-orientacoes",
  mixins: [util],
  components: {
    /*Componentes utilizados*/
    Migalha,
    Topo,
  },
  data() {
    //Declaracao de variaveis
    return {
      Vue: Vue,
      dialogDelete: false,
      idExclusao: null,
      showBox: true,
      valid: true,
      documentos: [],
      getPerfisSelec: [],
      arquivo: {
        nomDocumento: null,
        usuarioId: null,
        id_arquivo: null,
        file: null,
        //perfilUsuarioAcessoCaf: null,
        perfilUsuarioAcessoCaf: [],
        novoFile: null,
        id: 0,
        NomeArquivo:null
      },
      //perfilDocumentoCAF: null,
      perfilDocumentoCAF: [],
      loading: false,
      flExibirFormAddDocumento: false,
      flExibirFormEditDocumento: false,
      headers: [
        /*Cabeçalho da data-table*/
        {
          text: this.$t("label.nome"),
          align: "left",
          sortable: false,
          width: 300,
        },
        {
          text: "Data",
          align: "center",
          sortable: false,
          width: 70,
        },
        {
          text: this.$t("label.acoes"),
          align: "center",
          sortable: false,
          width: 120,
          class: "naoImprimir",
        },
      ],
      perfisDocumentos: [
        {
          descricao:'Perfil Cadastrador', tipo: 'C'
        }, 
        {
          descricao:'Perfil Fornecedor', tipo: 'F'
        }, 
        {
          descricao:'Perfil Validador', tipo: 'V'
        }
      ],
    };
  },
  async created() {
    await this.obterDocumentos();
  },
  methods: { //Declaracao de todos os metodos
    async obterDocumentos() {     
      await arquivoService.obterDocumentosGuias(this.$store.getters.getPerfil).then((result) => {
        const getReg = result.data;
        
        const newArray = getReg.map((m) => [m.nome, m]);
        const newMap = new Map(newArray);
        const iterator = newMap.values();
        const unique = [...iterator];
        this.documentos = unique;
      });      
    },

    async salvarDocumento(edit, id) {      
      let nomeDoc = this.arquivo.nomDocumento;
      let perfilCAF = this.perfilDocumentoCAF.length;
      let anexo = this.arquivo.file;      
      let arrayInfoNew = [];

      let qtdPerfis = this.perfilDocumentoCAF.length;
    
      if(nomeDoc != null && nomeDoc != "" && (anexo != null && anexo != undefined) && perfilCAF != null && perfilCAF != undefined) {       
        for (let i = 0; i < qtdPerfis; i++) {
          arrayInfoNew.push({
            NomeArquivo: this.arquivo.NomeArquivo,
            file: this.arquivo.file,
            id: id,          
            nomDocumento: this.arquivo.nomDocumento,
            novoFile: this.arquivo.novoFile,
            perfilUsuarioAcessoCaf: this.perfilDocumentoCAF[i].tipo,
            usuarioId: this.$store.getters.getUsuarioId,
            TituloArquivo: this.arquivo.file.filename
          })               
        }

        if (this.$refs.form.validate() && this.$verificaPerfilHabilitador()) {
          await arquivoService.salvar(arrayInfoNew).then((result) => {
            this.limparArquivo(edit);   
            this.obterDocumentos();          
            this.flExibirFormAddDocumento = false;
            this.flExibirFormEditDocumento = false;
            this.$toasted.success(result.data);
          });         
        }            
      } else {
        Vue.toasted.error(this.$t("messages.erro.camposObrigatorios"));
      }      
    },
    
    async editarDocumento(id) {        
      let nomeDoc = this.arquivo.nomDocumento;
      let perfilCAF = this.perfilDocumentoCAF;
    
      let arrayInfoNew = [];

      let qtdPerfis = this.perfilDocumentoCAF.length;

      let Titulo = "";
      
      if(this.arquivo.novoFile != null) {
        Titulo = this.arquivo.novoFile.filename;
      } else {
        Titulo = this.arquivo.file;
      }

      if(nomeDoc != null && nomeDoc != "" && perfilCAF != null && perfilCAF != undefined) {
        for (let i = 0; i < qtdPerfis; i++) {
          arrayInfoNew.push({
            NomeArquivo: this.arquivo.NomeArquivo,
            file: this.arquivo.file,
            id: id,          
            nomDocumento: this.arquivo.nomDocumento,
            novoFile: this.arquivo.novoFile,
            perfilUsuarioAcessoCaf: this.perfilDocumentoCAF[i].tipo,
            usuarioId: this.$store.getters.getUsuarioId,
            TituloArquivo: Titulo
          })               
        }
        
        if (this.$refs.form.validate() && this.$verificaPerfilHabilitador()) {
          await arquivoService.editar(arrayInfoNew).then((result) => {    
            this.limparArquivo(true);           
            this.obterDocumentos();          
            this.flExibirFormAddDocumento = false;
            this.flExibirFormEditDocumento = false;
            this.$toasted.success(result.data);
          });         
        }            
      } else {
        Vue.toasted.error(this.$t("messages.erro.camposObrigatorios"));
      }      
    },

    async excluirDocumento() {
      if(this.$verificaPerfilHabilitador()) {
        await arquivoService.excluirDocumento(this.idExclusao).then((result) => {
          this.obterDocumentos();
          this.limparArquivo();
          this.dialogDelete = false;
          this.$toasted.success(result.data);
        });
      }
    },
    async limparArquivo(edit) {    
      if(!edit && this.arquivo.novoFile == null){
         this.$refs.fileLimp._data.fakeFale = null;
      }
      this.arquivo.file = null;
      this.arquivo.novoFile = null;
      this.arquivo.nomDocumento = null;
      this.arquivo.id = 0;
      this.arquivo.idArquivo = null;
      this.arquivo.perfilUsuarioAcessoCaf = [];      
      this.perfilDocumentoCAF = [];     
    },

    async limparCampos() {      
      this.arquivo.file = null;
      this.arquivo.novoFile = null;
      this.arquivo.nomDocumento = null;
      this.arquivo.id = 0;
      this.arquivo.idArquivo = null;
      this.arquivo.perfilUsuarioAcessoCaf = [];      
      this.perfilDocumentoCAF = [];     
    },

    editarArquivo(itemArquivo){    
      this.arquivo.file = itemArquivo.nomeArquivo;
      this.arquivo.nomDocumento = itemArquivo.nome;
      this.arquivo.id = itemArquivo.id;
      let descPerfil = this.perfisDocumentos.filter(x => x.tipo == itemArquivo.perfilUsuarioAcessoCaf);  
      this.perfilDocumentoCAF = descPerfil ? descPerfil[0] : null;  
    },

    async editarArquivoMulti(itemArquivo){      
      let idArqAtual = itemArquivo.idArquivo;
      
      await arquivoService.retornaArqsPerfis(idArqAtual).then((result) => {
        this.arquivo.file = itemArquivo.tituloArquivo;
        this.arquivo.nomDocumento = itemArquivo.nome;
        this.arquivo.id = itemArquivo.id;
        this.arquivo.idArquivo = itemArquivo.idArquivo;
        let descPerfil = this.perfisDocumentos.filter(x => result.data.some(a => a == x.tipo));  
        this.perfilDocumentoCAF = descPerfil
      });     
    },

    subStrUpload(str) {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

      //Se for link
      if(regex .test(str)) {     
        return  str.substring(0,35)+'...';
      }
      return str != null ? str.substring(str.indexOf("_") + 1) : str;
    },
  },
};
</script>
<style>
.btn.focus, .btn:focus, .san {
    outline: 0;
    box-shadow: none!important;
    border: none;
}
.inputIcon {
  position: relative;
}

.inputIcon [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.inputIcon .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.inputIcon .v-text-field__slot {
  border-right: 0;
}

.inputIcon .v-input__icon--clear {
    border-radius: 0;
		border-right: 0 none !important;
}

.inputIcon .v-input__icon {
  align-self: center !important;
  min-height: 50px;
  border: solid 1px #eee;
  border-left: none;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}
</style>
